import React, { useState } from 'react';
import './ContactSection.css';
import { FaPhone, FaMapMarkerAlt, FaClock } from 'react-icons/fa';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Could integrate with emailjs here
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <section className="contact-section" id="contact">
      <h2 className="section-title">Contact Us</h2>
      <p className="section-subtitle">
        Get in touch with us for bookings and inquiries
      </p>
      <div className="contact-wrapper">
        {/* <div className="contact-form-wrapper">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div>
              <label>Name</label>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>Email</label>
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div>
              <label>Phone</label>
              <input
                type="tel"
                name="phone"
                placeholder="Your Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>Message</label>
              <textarea
                name="message"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>
            <button type="submit" className="contact-submit-btn">
              Send Message
            </button>
          </form>
        </div> */}

        <div className="contact-info-wrapper">
          <div className="contact-info-list">
            <div className="contact-info-item">
              <div className="contact-info-icon">
                <FaPhone />
              </div>
              <div className="contact-info-text">
                <h4>Phone</h4>
                <p>+91 9448082840 : Vivek</p>
                <p>+91 9740570582 : Kanthraju</p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-info-icon">
                <FaMapMarkerAlt />
              </div>
              <div className="contact-info-text">
                <h4>Location</h4>
                <p>Stadium Road Kuvempunagar,<br />
                  Venkatesh Rao Colony,<br />
                  Tumakuru, Karnataka 572103</p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-info-icon">
                <FaClock />
              </div>
              <div className="contact-info-text">
                <h4>Business Hours</h4>
                <p>Monday - Sunday: 9:00 AM - 7:00 PM</p>
              </div>
            </div>
          </div>

          <div className="contact-map">
            <iframe
              title="GMB Complex Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3871.897!2d77.1199452!3d13.3419388!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb02d82112bf5df%3A0x7feeb0fe65039e10!2sGowri%20Prasanna%20convention%20hall%20G.M.B%20complex!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
